import axios from 'axios'
import { ViewSet } from './base';
import { API_HOST } from '../consts'

const prefix = 'academico'

class TermYearsApi {
  constructor() {
    this.endpoint = 'term_years'
  }

  list = async ( params ) => {
    const response = await axios.get( `${API_HOST}/${prefix}/${this.endpoint}`, {
      params,
    } )
    return response.data
  };
}

class AcademicDegreeApi {
  constructor() {
    this.endpoint = 'academic_degrees'
  }

  list = async ( params ) => {
    const response = await axios.get( `${API_HOST}/${prefix}/${this.endpoint}`, {
      params,
    } )
    return response.data
  };
}

export { TermYearsApi, AcademicDegreeApi }

export const fetchAttendedPeriods = () =>
  axios
    .get( `${API_HOST}/academico/students/me/attended-periods` )
    .then( ( response ) => response.data )

export const fetchStudentClassesOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/student_classes`, { params } )
    .then( ( response ) => response.data )

export const fetchAreaOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/areas`, { params } )
    .then( ( response ) => response.data )

export const fetchGrauOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/graus`, { params } )
    .then( ( response ) => response.data )

export const fetchCursoStatusOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/curso_status`, { params } )
    .then( ( response ) => response.data )

export const fetchCursoVinculadoOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/cursos_vinculados`, { params } )
    .then( ( response ) => response.data )

export const fetchTurnoOptions = ( params ) =>
  axios
    .get( `${API_HOST}/academico/turnos`, { params } )
    .then( ( response ) => response.data )

export const fetchTurmaDisciplinaAlunoSupplementary = ( params ) =>
  axios
    .get( `${API_HOST}/academico/turma_disciplina_aluno/supplementary_data`, {
      params,
    } )
    .then( ( response ) => response.data.results )

export const fetchTurmaDisciplina = ( params ) =>
  axios
    .get( `${API_HOST}/academico/turma_disciplina`, { params } )
    .then( ( res ) => res.data )
    .catch( ( err ) => {
      throw err
    } )

export const fitStudents = ( data ) =>
  axios
    .post( `${API_HOST}/academico/turma_disciplina_aluno/fit_students`, data )
    .then( ( response ) => response )
    .catch( ( err ) => {
      throw err
    } )

export const fetchLogEnturmacao = () =>
  axios
    .get( `${API_HOST}/academico/log_enturmacao` )
    .then( ( response ) => response.data )
    .catch( ( err ) => {
      throw err
    } )

export const createDiscipline = async ( data ) =>
  await axios
    .post( `${API_HOST}/academico/disciplinas`, data )
    .then( ( res ) => res.data )

export const listDisciplines = async ( params ) =>
  await axios
    .get( `${API_HOST}/academico/disciplinas`, { params } )
    .then( ( res ) => res.data )

export const getDiscipline = async ( id ) =>
  await axios
    .get( `${API_HOST}/academico/disciplinas/${id}` )
    .then( ( res ) => res.data )

export const editDisciplines = async ( id, data ) =>
  await axios
    .patch( `${API_HOST}/academico/disciplinas/${data.id}`, data )
    .then( ( res ) => res.data )

export const deleteDiscipline = ( id ) =>
  axios
    .delete( `${API_HOST}/academico/disciplinas/${id}` )
    .then( ( response ) => response.data )

export const fetchTerms = ( params ) =>
  axios
    .get( `${API_HOST}/academico/term`, { params } )
    .then( ( response ) => response.data )

export const getTerm = ( id ) =>
  axios
    .get( `${API_HOST}/academico/term/${id}` )
    .then( ( response ) => response.data )

export const editTerm = ( id, values ) =>
  axios
    .patch( `${API_HOST}/academico/term/${id}`, values )
    .then( ( response ) => response.data )

export const createTerm = ( data ) =>
  axios
    .post( `${API_HOST}/academico/term`, data )
    .then( ( response ) => response.data )

export const deleteTerm = ( id ) =>
  axios
    .delete( `${API_HOST}/academico/term/${id}` )
    .then( ( response ) => response.data )

export const createTermYear = ( data ) =>
  axios
    .post( `${API_HOST}/academico/term_years`, data )
    .then( ( response ) => response )

export const editTermYear = ( data ) =>
  axios
    .put( `${API_HOST}/academico/term_years/${data.id}`, data )
    .then( ( response ) => response )

export const fetchTermsYears = ( params ) =>
  axios
    .get( `${API_HOST}/academico/term_years`, { params } )
    .then( ( response ) => response.data )

export const getTermYear = ( id ) =>
  axios
    .get( `${API_HOST}/academico/term_years/${id}` )
    .then( ( response ) => response.data )

export const deleteTermYear = ( id ) =>
  axios
    .delete( `${API_HOST}/academico/term_years/${id}` )
    .then( ( response ) => response.data )

export const getPreceptores = ( params ) =>
  axios
    .get( `${API_HOST}/academico/preceptores`, { params } )
    .then( ( response ) => response.data )

export const createPreceptor = ( data ) =>
  axios
    .post( `${API_HOST}/academico/preceptores`, data )
    .then( ( response ) => response.data )

export const editPreceptor = ( id, data ) =>
  axios
    .patch( `${API_HOST}/academico/preceptores/${id}`, data )
    .then( ( response ) => response.data )

export const deletePreceptor = ( id ) =>
  axios
    .delete( `${API_HOST}/academico/preceptores/${id}` )
    .then( ( response ) => response.data )

export const getPreceptorsAcademicDegrees = ( data ) =>
  axios
    .get( `${API_HOST}/academico/preceptor_academic_degrees`, data )
    .then( ( response ) => {
      let results = []
      for ( let obj of response.data ) {
        results.push( { id: obj.academic_degree.id, name: obj.academic_degree.name } )
      }
      return results
    } )

export const getEducationalStages = async () =>
  await axios
    .get( `${API_HOST}/academico/educational_stage` )
    .then( ( res ) => res.data )


export class SupplementaryHoursApplicationApi extends ViewSet {
  prefix = 'academico';

  endpoint = 'supplementary_hours_application_tickets';
}
